define("shared/utils/search/calculate-match-ratio", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f

  /**
   * @module Utils
   */

  /**
   * @class calculateMatchRatio
   * @extends Utils
   */

  /**
   *
   * @method calculateMatchRatio
   * @param {String} query string containing entire query
   * @param {String} keyword specific keyword to check match ratio for query.
   *
   * @return {Number} Value of matching for keyword within query
   */
  const calculateMatchRatio = (query, keyword) => {
    const {
      length: queryLength
    } = query;
    const {
      length: keywordLength
    } = keyword;
    const keywordAsPercentOfQuery = keywordLength / queryLength;
    const queryAsPercentOfKeyword = queryLength / keywordLength;
    return queryLength >= keywordLength ? keywordAsPercentOfQuery : queryAsPercentOfKeyword;
  };

  var _default = calculateMatchRatio;
  _exports.default = _default;
});